import { EntityMediaType, MediaKindEnum } from '@/types/schema';

export const getMediaDuration = async (media: EntityMediaType) => {
  if (!media?.url || media.kind !== MediaKindEnum.Video) return;
  //TODO: Fix for web
  return '30:42';
};
export const isAudio = (media: Partial<EntityMediaType>) =>
  media.kind === MediaKindEnum.Audio || media.mimeType?.includes('audio/');
export const isVideo = (media: Partial<EntityMediaType>) =>
  media.kind === MediaKindEnum.Video || media.mimeType?.includes('video/');
export const isImage = (media: Partial<EntityMediaType>) =>
  media.kind === MediaKindEnum.Image || media.mimeType?.includes('image/');
export const isPdf = (media: Partial<EntityMediaType>) =>
  [MediaKindEnum.Document, MediaKindEnum.File].includes(media.kind!) &&
  media.mimeType?.includes('pdf');
